import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, helpers), {}, {
  detailsTable: {
    marginTop: '20px',
    '& .MuiTableCell-root': {
      padding: '5px 0'
    }
  },
  status: {
    padding: '20px 40px'
  },
  tenantName: {
    background: palette.success.gradient,
    '&.MuiListItem-root': {
      padding: '24px',
      height: '90px'
    }
  },
  Ok: {
    background: palette.success.gradient
  },
  Due: {
    background: palette.warning.gradient
  },
  Overdue: {
    background: palette.error.gradient
  },
  paperBody: {
    padding: '0 40px 50px 40px',
    marginTop: '10px',
    flexGrow: '1',
    display: 'flex',
    flexDirection: 'column'
  },
  balanceTable: {
    marginTop: '20px',
    marginBottom: '10px',
    paddingBottom: '10px',
    flexGrow: '1'
  },
  summaryWrapper: {
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    marginTop: '20px'
  },
  summary: {
    backgroundColor: palette.shades[200],
    flexGrow: 1,
    padding: '0 16px',
    display: 'flex',
    alignItems: 'center',
    height: '64px'
  },
  summaryAmount: {
    maxWidth: '200px',
    marginLeft: '4px',
    justifyContent: 'flex-end'
  },
  balance: {
    display: 'flex',
    marginLeft: '6px',
    alignItems: 'center'
  },
  listFooter: {
    padding: '24px',
    borderTop: "1px solid ".concat(palette.shades[300]),
    backgroundColor: palette.shades[200],
    flexGrow: '1',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '& .MuiButton-root': {
      width: '100%'
    }
  },
  iconWrapper: {
    marginRight: '20px'
  }
}));
export default useStyles;